import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import strings from 'utils/strings.js'

export default function SearchTips(props) {
  return (
    <StyledSearchTips>
      <div>
        {props.children || (
          <div>
            <StyledList>
              <li>{strings.search_tips_point_1}</li>
              <li>{strings.search_tips_point_2}</li>
              <li>{strings.search_tips_point_3}</li>
            </StyledList>
          </div>
        )}
      </div>
    </StyledSearchTips>
  )
}

SearchTips.propTypes = {
  children: PropTypes.node,
}

const StyledSearchTips = styled.div`
  font-size: 12px;
  line-height: 1.29;
  width: 310px;

  && h5 {
    font-size: 12px;
    font-weight: bold;
    color: #fff;
  }
`

const StyledList = styled.ul`
  margin: 0px;
  padding-left: 16px;
`
